<button ion-item class="container-btn" (click)="onClick.emit()">
  <h2><span class="text-main">{{ item?.name | translate}}</span></h2>
  <h2><span class="text-description">{{ item?.description | translate }}</span></h2>
  <p *ngIf="item?.preround"><span class="text-prefix">{{'GROUP_STAGE' | translate}}:</span> {{ item.preround | translate }}</p>
  <p *ngIf="item?.finalround"><span class="text-prefix">{{'FINAL_ROUND' | translate}}:</span> {{ item.finalround | translate }}</p>
  <p *ngIf="item?.finalstage"><span class="text-prefix">{{'FINAL_PHASE' | translate}}:</span> {{ item.finalstage | translate }}</p>
  <p *ngIf="item?.place">{{ item?.place }}</p>
  <p *ngIf="item?.additional" class="text-additional">{{ item.additional | translate }}</p>
</button>